<template>
  <div style="text-align: center;">
    <div v-if="!hasError">
      <van-col :span="24" style="text-align: center;">
        生产单信息
      </van-col>
      <base-input v-model="currProduceOrder.order_date" label="订单时间" readonly />
      <base-input v-model="currProduceOrder.code" label="订单号" readonly />
      <base-input-number v-model="currProduceOrder.total_amount" label="订单金额" readonly />
      <base-input v-model="currProduceOrder.orderer" label="订货人" readonly />
      <base-input v-model="currProduceOrder.delivery_time" label="送货时间" readonly />
      <van-col :span="24" v-for="(detail, index) in currProduceOrder.details" :key="detail.key" style="text-align: left;">
        <van-card :num="detail.count" :price="detail.price" :desc="detail.goods_name" :title="'产品' + (index + 1)"
                  thumb="https://img.yzcdn.cn/vant/ipad.jpeg">
          <div slot="tags">
            <van-tag plain type="danger" v-if="detail.type_name">{{ detail.type_name }}</van-tag>
            <van-tag plain type="primary" v-if="detail.specs">{{ detail.specs }}</van-tag>
          </div>
        </van-card>
        <van-col :span="14">
          <base-input-number v-model="detail.amount" label="小计" readonly />
        </van-col>
        <van-col :span="24">
          <base-textarea v-model="detail.remark" label="特殊要求" readonly />
        </van-col>
      </van-col>
      <van-col v-if="this.currProduceOrder.un_quality && this.currProduceOrder.un_quality.picture" span="17"
               style="font-size: 15px; font-weight: bold; color: #ff4949;">
        此生产单质检不合格！
      </van-col>
      <van-col v-else-if="qualityStatus === CONST.QUALITY_STATUS.find(status => status.name === '待质检').id" span="17"
               style="font-size: 15px; font-weight: bold; color: #ff4949;">
        注意：拍照时请确保图片拍摄清晰！
      </van-col>
      <van-col v-else span="17" style="font-size: 15px; font-weight: bold; color: #13ce66;">
        此生产单质检合格！
      </van-col>
      <van-col :span="24">
        <van-progress
          v-if="uploading"
          :percentage="uploadingPercentage"
          :pivot-text="uploadingMsg"
          color="#13ce66"
        />
        <van-steps :active="3">
          <van-step>开始拍照</van-step>
          <van-step>等待上传</van-step>
          <van-step>上传完成</van-step>
        </van-steps>
        <van-uploader accept="*" v-model="fileList" :max-count="1" upload-text="请选择文件"
                      :disabled="uploadData.content.trim().length === 0 || !canUpload"
                      :deletable="false" multiple :after-read="afterRead" :before-delete="beforeDelete" />
      </van-col>
      <van-col :span="24">
        <base-textarea v-model="uploadData.content" label="质检结果" :readonly="!canUpload" />
      </van-col>
    </div>
    <div v-else>
      <span style="font-size: 16px; font-weight: bold; color: #ff4949;">{{ errorMsg }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { unQualityProduceOrder, getProduceOrderList } from '@/api/produce/order'
import { wxJsConfig } from '@/api/commons'
export default {
  name: "DeliveryArrived",
  data() {
    return {
      uploading: false,
      uploadingMsg: '',
      uploadingPercentage: 0,
      canUpload: false,

      fileOrd: 1,
      fileList: [],
      uploadData: {
        main_id: 0,
        content: ''
      },
      qualityStatus: this.CONST.QUALITY_STATUS.find(status => status.name === '待质检').id,
      hasError: false,
      errorMsg: '',
      currProduceOrder: {}
    }
  },
  computed: {
    ...mapGetters(['token'])
  },
  async mounted() {
    this.uploadData.main_id = parseInt(this.$route.query.id)
    if (this.uploadData.main_id) {
      const produceOrderResp = await getProduceOrderList({ id: this.uploadData.main_id })
      const produceOrderRows = produceOrderResp.rows || []
      if (produceOrderRows.length > 0) {
        this.currProduceOrder = produceOrderRows[0]
        if (this.currProduceOrder.un_quality && this.currProduceOrder.un_quality.picture) {
          this.fileList.push({
            url: `${this.BACKEND_API}/${this.currProduceOrder.un_quality.picture}?token=${this.token}`,
            status: 'done'
          })
          this.uploadData.content = this.currProduceOrder.un_quality.content || ''
        } else if (this.currProduceOrder.quality_status === this.CONST.QUALITY_STATUS.find(status => status.name === '合格').id) {
        } else {
          this.canUpload = true
        }
        this.qualityStatus = this.currProduceOrder.quality_status
      } else {
        this.hasError = true
        this.errorMsg = '参数错误，获取订单信息失败'
        this.alert(this.errorMsg)
      }
    } else {
      this.hasError = true
      this.errorMsg = '参数错误，请您从企业微信端进入'
      this.alert(this.errorMsg)
    }
  },
  methods: {
    beforeDelete(file) {
      return new Promise((resolve, reject) => {
        reject()
        // deleteImage({
        //   id: file.obj.id,
        //   open_id: this.uploadData.open_id
        // }).then(resp => {
        //   if (resp.success) {
        //     resolve()
        //     Toast(resp.msg)
        //   } else {
        //     reject()
        //   }
        // });
      })
    },
    async afterRead(file) {
      this.canUpload = false
      this.uploading = true
      this.uploadingPercentage = 0
      let files = []
      if (file instanceof Array) {
        files = file
      } else {
        files.push(file)
      }
      try {
        for (let i = 0; i < files.length; i++) {
          this.uploadingPercentage = parseFloat(parseFloat((i + 1) / files.length * 100).toFixed(2))
          this.uploadingMsg = ` ${i + 1}/${ files.length }`

          let originFile = files[i]
          let suffixPos = originFile.file.name.lastIndexOf('.')
          let suffixName = originFile.file.name.substring(suffixPos + 1)
          let isImg = this.CONST.IMAGE_TYPES.find(type => type === suffixName) != null
          if (isImg) {
            let rst = await this.lrz(originFile.file)
            await this.uploadFile(originFile, rst.formData, this.fileOrd++)
          } else {
            let formData = new FormData()
            formData.append('file', originFile.file)
            await this.uploadFile(originFile, formData, this.fileOrd++)
          }
        }
        this.canUpload = false // 标记不合格后不能再上传图片
        this.qualityStatus = this.CONST.QUALITY_STATUS.find(status => status.name === '不合格').id
        this.alert('上传质检结果成功')
      } catch (error) {
        this.canUpload = true
        this.error(error)
        this.alert(error)
      }
      this.uploadingPercentage = 100
      this.uploading = false
    },
    uploadFile(originFile, formData, ord) {
      return new Promise((resolve, reject) => {
        for(const key in this.uploadData) {
          formData.append(key, this.uploadData[key])
        }
        unQualityProduceOrder(formData).then(resp => {
          if (resp.success) {
            console.log('文件上传成功 ord: ', ord)
            this.success(resp.msg)
            resolve()
          } else {
            console.error('文件上传失败 ord: ', ord)
            this.delFile(originFile)
            reject(resp.msg)
          }
        }).catch(error => {
          console.error('文件上传失败 ord: ', ord)
          this.delFile(originFile)
          reject(error.message)
        })
      })
    },
    delFile(file) {
      let index = this.fileList.indexOf(file);
      if (index !== -1) {
        this.fileList.splice(index, 1);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bind-produce/un-quality.vue